<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('housekeepingTypeManage.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="housekeepingTypeManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="housekeepingTypeManageInfo.conditions.hktName"
                :placeholder="$t('housekeepingTypeManage.inputTypeName')"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-select v-model="housekeepingTypeManageInfo.conditions.isShow" style="width:100%"
              :placeholder="$t('housekeepingTypeManage.selectShowStatus')">
              <el-option :label="$t('housekeepingTypeManage.all')" value=""></el-option>
              <el-option :label="$t('housekeepingTypeManage.yes')" value="Y"></el-option>
              <el-option :label="$t('housekeepingTypeManage.no')" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryHousekeepingTypeMethod()">
              {{ $t('housekeepingTypeManage.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('housekeepingTypeManage.housekeepingMenu') }}</div>
          <el-button type="primary" size="small" @click="_openAddHousekeepingTypeModal()">
            <i class="el-icon-plus"></i>
            {{ $t('housekeepingTypeManage.add') }}
          </el-button>
      </div>
      <div class="">
        <el-table :data="housekeepingTypeManageInfo.housekeepingTypes" border style="width: 100%">
          <el-table-column prop="hktIcon" :label="$t('housekeepingTypeManage.smallIcon')" align="center">
            <template #default="{ row }">
              <img style="width: 60px; height: 60px; border-radius: 5px;" :src="row.hktIcon" />
            </template>
          </el-table-column>
          <el-table-column prop="hktName" :label="$t('housekeepingTypeManage.menuName')"
            align="center"></el-table-column>
          <el-table-column prop="hktDesc" :label="$t('housekeepingTypeManage.menuDesc')"
            align="center"></el-table-column>
          <el-table-column prop="label" :label="$t('housekeepingTypeManage.label')" align="center"></el-table-column>
          <el-table-column prop="seq" :label="$t('housekeepingTypeManage.sort')" align="center"></el-table-column>
          <el-table-column prop="isShow" :label="$t('housekeepingTypeManage.isShow')" align="center">
            <template #default="{ row }">
              {{ row.isShow == 'Y' ? $t('housekeepingTypeManage.yes') : $t('housekeepingTypeManage.no') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('housekeepingTypeManage.operation')" align="center" width="200">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="mini" @click="_openEditHousekeepingTypeModel(row)">
                  {{ $t('housekeepingTypeManage.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteHousekeepingTypeModel(row)">
                  {{ $t('housekeepingTypeManage.delete') }}
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="housekeepingTypeManageInfo.conditions.page"
          :page-size="housekeepingTypeManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="housekeepingTypeManageInfo.total"></el-pagination>
      </div>
    </el-card>

    <add-housekeeping-type ref="addHousekeepingType" @success="_listHousekeepingTypes"></add-housekeeping-type>
    <edit-housekeeping-type ref="editHousekeepingType" @success="_listHousekeepingTypes"></edit-housekeeping-type>
    <delete-housekeeping-type ref="deleteHousekeepingType" @success="_listHousekeepingTypes"></delete-housekeeping-type>
  </div>
</template>

<script>
import { queryHousekeepingType } from '@/api/admin/housekeepingTypeApi'
import AddHousekeepingType from '@/components/admin/addHousekeepingType/addHousekeepingType.vue'
import EditHousekeepingType from '@/components/admin/editHousekeepingType/editHousekeepingType.vue'
import DeleteHousekeepingType from '@/components/admin/deleteHousekeepingType/deleteHousekeepingType.vue'

export default {
  name: 'HousekeepingTypeManage',
  components: {
    AddHousekeepingType,
    EditHousekeepingType,
    DeleteHousekeepingType
  },
  data() {
    return {
      housekeepingTypeManageInfo: {
        housekeepingTypes: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          hktName: '',
          isShow: '',
          shopId: '9999',
          typeCd: '1001',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listHousekeepingTypes()
  },
  methods: {
    async _listHousekeepingTypes() {
      try {
        const res = await queryHousekeepingType(this.housekeepingTypeManageInfo.conditions)
        this.housekeepingTypeManageInfo.housekeepingTypes = res.data
        this.housekeepingTypeManageInfo.total = res.total
        this.housekeepingTypeManageInfo.records = res.records
        console.log(this.housekeepingTypeManageInfo.moreCondition)
      } catch (error) {
        console.error('获取家政类型列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.housekeepingTypeManageInfo.conditions.page = val
      this._listHousekeepingTypes()
    },
    _queryHousekeepingTypeMethod() {
      this.housekeepingTypeManageInfo.conditions.page = 1
      this._listHousekeepingTypes()
    },
    _openAddHousekeepingTypeModal() {
      this.$refs.addHousekeepingType.open({ typeCd: '1001' })
    },
    _openEditHousekeepingTypeModel(row) {
      this.$refs.editHousekeepingType.open(row)
    },
    _openDeleteHousekeepingTypeModel(row) {
      this.$refs.deleteHousekeepingType.open(row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  padding: 15px 20px 20px;
}
</style>